export default "__VITE_ASSET__F52AbTPu__"